/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {
    CLOSE_TERMS,
    OPEN_TERMS,
} from "../Actions/Types/termsActionTypes";

const initialState = {
    termsOpen: false,
};

export const termsReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPEN_TERMS:
            return {
                ...state,
                termsOpen: true,
            };
        case CLOSE_TERMS:
            return {
                ...state,
                termsOpen: false,
            };
    }
    return state;
};
